var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountrySb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9697)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9697)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "url(#paint0_linear_2858_9697)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2858_9697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H28L0 20V0Z",
    fill: "url(#paint1_linear_2858_9697)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0L0 20H28V0Z",
    fill: "#2C7442"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.77344,
    y: 19.7057,
    width: 33.5473,
    height: 23.8329,
    transform: "rotate(-34 -2.77344 19.7057)",
    fill: "#FFD646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02049 4.34828L2.20759 3.25743L1.41504 2.48489L2.51031 2.32574L3.00013 1.33325L3.48995 2.32574L4.58523 2.48489L3.79268 3.25743L3.97978 4.34828L3.00013 3.83325L2.02049 4.34828ZM8.68702 4.34828L8.87412 3.25743L8.08157 2.48489L9.17685 2.32574L9.66667 1.33325L10.1565 2.32574L11.2518 2.48489L10.4592 3.25743L10.6463 4.34828L9.66667 3.83325L8.68702 4.34828ZM8.87412 7.25743L8.68702 8.34828L9.66667 7.83325L10.6463 8.34828L10.4592 7.25743L11.2518 6.48489L10.1565 6.32574L9.66667 5.33325L9.17685 6.32574L8.08157 6.48489L8.87412 7.25743ZM3.00013 7.83325L2.02049 8.34828L2.20759 7.25743L1.41504 6.48489L2.51031 6.32574L3.00013 5.33325L3.48995 6.32574L4.58523 6.48489L3.79268 7.25743L3.97978 8.34828L3.00013 7.83325ZM5.35402 6.34828L6.33366 5.83325L7.3133 6.34828L7.12621 5.25743L7.91875 4.48489L6.82348 4.32574L6.33366 3.33325L5.84384 4.32574L4.74856 4.48489L5.54111 5.25743L5.35402 6.34828Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2858_9697",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2858_9697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2858_9697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_9697",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159B3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2858_9697",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0660D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9697"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrySb);
export default __webpack_public_path__ + "static/media/Country=SB.0df0cb2db24590aba40afcc758bc1067.svg";
export { ForwardRef as ReactComponent };